<template lang="pug">
  el-dialog(:title="!dataForm.id ? '新增' : '修改'", top="5vh", :close-on-click-modal='false', :visible.sync='visible' append-to-body)
    el-form(:model='dataForm', :rules='dataRule', ref='dataForm',  label-width='100px')
      el-form-item(label='用户名:', prop='userName')
        el-input(v-model='dataForm.userName', placeholder='请填写用户名')
      el-form-item(label='主办方:', prop='orgId')
        el-select(v-model="dataForm.orgId",placeholder="请选择主办方",filterable,clearable,@change="change()")
          el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId")
        input(type="text" value="1" style="transform: scale(0);")
      el-form-item(label='数据权限设置:', prop='dataAuthority')
        el-radio-group(v-model="dataForm.dataAuthority")
          el-radio(:label="1") 全部
          el-radio(:label="2") 仅本主办方
      el-form-item(label='选择角色:' )
        el-table(:data='roleList', border='',ref="multipleTable", @selection-change='selectionChangeHandle', style='width: 100%;')
                el-table-column(prop='roleName', header-align='center', align='center', label='角色名称')
                el-table-column(prop='remark', header-align='center', align='center', label='角色描述')
                el-table-column(type='selection',prop='roleId' header-align='center', align='center', width='50',label='选择')
      el-form-item(label='密码:', prop='password', :class="{ 'is-required': !dataForm.id }")
        el-input(v-model='dataForm.password', type='password', placeholder='密码')
        .psw-tip 密码必须包含英文大小写、数字、字符
      el-form-item(label='确认密码:', prop='comfirmPassword', :class="{ 'is-required': !dataForm.id }")
        el-input(v-model='dataForm.comfirmPassword', type='password', placeholder='确认密码')
      el-form-item(label='联系电话:', prop='mobile')
        el-input(v-model='dataForm.mobile', placeholder='请填写联系电话')
      el-form-item(label='邮箱地址:', prop='email')
        el-input(v-model='dataForm.email', placeholder='请填写邮件地址')
      el-form-item(label='用户介绍:', prop='detail')
        el-input(type="textarea" :rows=5 resize="none" v-model="dataForm.detail",  placeholder='请填写用户介绍')
        //- el-checkbox-group(v-model='dataForm.roleIdList')
        //-   el-checkbox(v-for='role in roleList', :key='role.roleId', :label='role.roleId') {{ role.roleName }}
      //- el-form-item(label='状态', size='mini', prop='status')
      //-   el-radio-group(v-model='dataForm.status')
      //-     el-radio(:label='0') 禁用
      //-     el-radio(:label='1') 正常
    span.dialog-footer(slot='footer')
      el-button(@click='visible = false') 取消
      el-button(type='primary', @click='dataFormSubmit()' :disabled="clickFlag") 确定
</template>

<script>
import { isEmail, isMobile } from '@/util/validate'
export default {
  data () {
    var validatePassword = (rule, value, callback) => {
      if (!this.dataForm.id && !/\S/.test(value)) {
        callback(new Error('密码不能为空'))
      } else {
        callback()
      }
    }
    var validateComfirmPassword = (rule, value, callback) => {
      if (!this.dataForm.id && !/\S/.test(value)) {
        callback(new Error('确认密码不能为空'))
      } else if (this.dataForm.password !== value) {
        callback(new Error('确认密码与密码输入不一致'))
      } else {
        callback()
      }
    }
    return {
      clickFlag: false,
      visible: false,
      roleList: [],
      sysOrgList: [],
      dataListSelections: [],
      dataForm: {
        id: 0,
        userName: '',
        password: '',
        comfirmPassword: '',
        salt: '',
        email: '',
        mobile: '',
        userRoleList: [],
        status: 1,
        orgId: '',
        detail: '',
        dataAuthority: 1
      },
      dataRule: {
        // roleId: [
        //   { required: true, message: '至少选择一个角色', trigger: 'blur' }],
        userName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        orgId: [{ required: true, message: '主办方不能为空', trigger: 'blur' }],
        password: [
          { validator: validatePassword, trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        comfirmPassword: [
          { validator: validateComfirmPassword, trigger: 'blur' }
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的E-mail',
            trigger: 'blur,change'
          }
        ],
        mobile: [
          { required: true, message: '请填写联系电话', trigger: 'blur' },
          { pattern: /^1[12345789]\d{9}$/, message: '请输入正确的手机号码' },
        ],
        detail: [
          {
            min: 1,
            max: 300,
            message: '长度在 1 到 300 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.clickFlag = false
      this.dataForm.id = id || 0
      this.$http({
        url: this.$http.adornUrl('/sys/role/select'),
        method: 'get',
        params: this.$http.adornParams()
      })
        .then(data => {
          this.roleList = data && data.code === 0 ? data.list : []
        })
        .then(() => {
          this.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
          })
        })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl('/sysOrg/list'),
            method: 'get',
            params: this.$http.adornParams({
              cityId: this.dataForm.cityId,
              proviceId: this.dataForm.proviceId
            })
          }).then(data => {
            this.sysOrgList = data && data.code === 0 ? data.list : []
          })
        })
        .then(() => {
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/sys/user/info/${this.dataForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(data => {
              if (data && data.code === 0) {
                this.dataForm.userName = data.user.username
                this.dataForm.salt = data.user.salt
                this.dataForm.email = data.user.email
                this.dataForm.mobile = data.user.mobile
                this.dataForm.userRoleList = data.user.userRoleList
                this.dataForm.status = data.user.status
                this.dataForm.detail = data.user.detail
                this.dataForm.orgId = data.user.orgId
                this.dataForm.dataAuthority = data.user.dataAuthority
                this.$nextTick(() => {
                  for (let i = 0; i < this.dataForm.userRoleList.length; i++) {
                    for (let j = 0; j < this.roleList.length; j++) {
                      if (
                        this.dataForm.userRoleList[i].roleId ==
                        this.roleList[j].roleId
                      ) {
                        this.$refs.multipleTable.toggleRowSelection(
                          this.roleList[j],
                          true
                        )
                      }
                    }
                  }
                })
              }
            })
          }
        })
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    change () {
      this.$forceUpdate()
    },
    // 表单提交
    dataFormSubmit (id) {
      var roleId = id
        ? [id]
        : this.dataListSelections.map(item => {
           return item.roleId
          })

      this.$refs['dataForm'].validate(valid => {
        if (roleId == '') {
          this.$message.error('至少选择一个角色')
          return
        }
        if (valid) {
          // this.clickFlag = true
          // this.$http({
          //     url: this.$http.adornUrl('/sys/user/checkUser'),
          //     method: 'get',
          //      params: this.$http.adornParams({
          //       'userId': this.dataForm.userId,
          //       'username' : this.dataForm.userName
          //    })
          //   }).then((data) => {
          //    console.log(data)
          //   })
          this.$http({
            url: this.$http.adornUrl(
              `/sys/user/${!this.dataForm.id ? 'save' : 'update'}`
            ),
            method: 'post',
            data: {
              userId: this.dataForm.id || undefined,
              username: this.dataForm.userName,
              password: this.dataForm.password,
              salt: this.dataForm.salt,
              email: this.dataForm.email,
              mobile: this.dataForm.mobile,
              status: this.dataForm.status,
              roleIdList: roleId,
              detail: this.dataForm.detail,
              orgId: this.dataForm.orgId,
              dataAuthority: this.dataForm.dataAuthority
            }
          }).then(data => {
            console.log(data)
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshdatalist')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>
<style>
.psw-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.el-table__header {
  width: 100% !important;
}
.el-table__body {
  width: 100% !important;
}
</style>